import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { themeSelector } from '@/state/config';
import styles from './PoweredBy.module.scss';
export const PoweredBy = memo(() => {
    const { t } = useTranslation();
    const theme = useRecoilValue(themeSelector);
    return (_jsx("span", { className: cn(styles.container, styles[theme]), children: _jsx(Trans, { i18nKey: "we_run_on", values: { brand: t('moveo_ai') }, components: [
                _jsx("a", { className: cn(styles.link), href: "https://moveo.ai?ref=web-client", target: "_blank", rel: "noreferrer noopener", "aria-label": t('moveo_ai') }, "moveo"),
            ] }) }));
});
PoweredBy.displayName = 'PoweredBy';
